export default __webpack_public_path__ + "static/media/idea-space.e21e978a.png";